const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    PHY_LOCATION_APIGATEWAY_URL: 'https://a4qycma7wf.execute-api.eu-west-1.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://vlcv1z1yc7.execute-api.eu-west-1.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://cxs6t33q81.execute-api.eu-west-1.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'hotfix/UP1-398-geojson-upsert-api',
    HOSTNAME: 'https://locations.testing.eurecovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.eurecovery.forwoodsafety.com',
    WEBSOCKET: 'wss://mx3s7li7i2.execute-api.eu-west-1.amazonaws.com/testing'
  },
};

export default config;